var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"custom-svg-icon"},[(_vm.componentRef)?_c(_vm.componentRef,{tag:"component",staticClass:"leftsideSvg",attrs:{"color":_vm.svgColor}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }